var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    fill: "#F8C000",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    stroke: "#F8C000",
    strokeOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0019 21.4991C24.9787 21.2212 24.9324 20.9201 24.8166 20.6653C24.7934 20.6422 24.7934 20.619 24.7703 20.5727L18.3088 9.29414C17.6372 8.0667 16.0855 7.62667 14.8581 8.29829C14.4412 8.52988 14.0938 8.87727 13.8623 9.27098L7.42398 20.5727C7.40082 20.5959 7.40082 20.619 7.37766 20.6653C6.845 21.9623 7.4703 23.4444 8.76722 23.9771C9.02197 24.0929 9.29988 24.1392 9.57779 24.1624H9.62411H22.5238H22.5701C23.2418 24.1392 23.8671 23.8382 24.3302 23.3286C24.7934 22.8191 25.025 22.1707 25.0019 21.4991ZM16.7572 19.7621C16.7572 20.1327 16.4561 20.4337 16.0855 20.4337C15.715 20.4337 15.4139 20.1327 15.4139 19.7621C15.4139 19.3916 15.715 19.0905 16.0855 19.0905C16.4561 19.1137 16.7572 19.3916 16.7572 19.7621ZM16.7803 17.2378C16.7803 17.6315 16.4793 17.9325 16.0855 17.9325C15.6918 17.9325 15.3908 17.6315 15.3908 17.2378V14.4818C15.3908 14.0881 15.6918 13.787 16.0855 13.787C16.4793 13.787 16.7803 14.0881 16.7803 14.4818V17.2378Z",
    fill: "#F8C000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifAlertIcon);
export default __webpack_public_path__ + "static/media/notifAlertIcon.6df9576a9bcb75ff8699e66e474fd23d.svg";
export { ForwardRef as ReactComponent };